<template>
  <v-row
    v-for="field in fields"
    :key="`${itemKeyPrefix}-${field.local_id}`"
    dense
    class="ncrm-onboarding-templates__field-row"
  >
    <v-col cols="12" md="4">
      <v-text-field
        v-model="field.label"
        :label="$t('ncrm.onboarding.templates.create.fieldsEditor.label')"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-select
        v-model="field.field_type"
        :items="fieldTypeOptions"
        item-title="label"
        item-value="value"
        :menu-props="selectMenuProps"
        :label="$t('ncrm.onboarding.templates.create.fieldsEditor.type')"
      >
        <template #item="{ props, item }">
          <v-list-item v-bind="props">
            <template #prepend>
              <v-icon size="18">{{ item.raw.icon }}</v-icon>
            </template>
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        v-model.number="field.sort_order"
        type="number"
        min="1"
        :label="$t('ncrm.onboarding.templates.create.fieldsEditor.sortOrder')"
      />
    </v-col>
    <v-col cols="12" md="2" class="d-flex align-center justify-end pb-md-5">
      <v-btn size="x-small" variant="text" color="error" @click="$emit('remove', field.local_id)">
        <v-icon size="16">mdi-delete-outline</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12" md="8">
      <v-text-field
        v-model="field.help_text"
        :label="$t('ncrm.onboarding.templates.create.fieldsEditor.helpText')"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-switch
        v-model="field.is_required"
        color="primary"
        inset
        :label="$t('ncrm.onboarding.templates.create.fieldsEditor.isRequired')"
      />
    </v-col>
    <v-col v-if="field.field_type === 'select'" cols="12">
      <v-combobox
        v-model="field.option_labels"
        multiple
        chips
        closable-chips
        clearable
        :menu-props="selectMenuProps"
        :label="$t('ncrm.onboarding.templates.create.fieldsEditor.options')"
      />
    </v-col>
    <v-col v-if="showDividers && field !== fields[fields.length - 1]" cols="12" class="pt-0">
      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "NcrmOnboardingTemplateFieldRows",
  inheritAttrs: false,
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    fieldTypeOptions: {
      type: Array,
      default: () => [],
    },
    selectMenuProps: {
      type: Object,
      default: () => ({}),
    },
    itemKeyPrefix: {
      type: String,
      default: "field",
    },
    showDividers: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["remove"],
};
</script>
